import React from "react";
import styled from "styled-components";
import { createGlobalStyle } from "styled-components";
import reset from "styled-reset";

import Menu from "./components/Menu";

const StyledPage = styled.div`
  margin-left: ${({ useMenu }) => useMenu && "190px"};
  box-sizing: border-box;
  padding: 24px;
  flex: 1;
  position: relative;
`;

const GlobalStyle = createGlobalStyle`
  ${reset}
  html, body {
    font-family: Arial, -apple-system, '.SFNSText-Regular', 'San Francisco', 'Segoe UI', 'Helvetica Neue', 'Lucida Grande', sans-serif;
    background: #F5F7F9;
    margin: 0;
    padding: 0;
    height: 100%;
  }
  
  a {
    text-decoration: none;
  }
  
  #__next {
    min-height: 100%;
    display: flex;
  }
`;

const StyledWrapperPage = styled.div`
  width: 100%;
`;

const SiteLayout = ({ children, enabled }, ref) => {
  return (
    <StyledWrapperPage ref={ref}>
      <GlobalStyle />
      {enabled && <Menu />}
      <StyledPage useMenu={enabled}>{children}</StyledPage>
    </StyledWrapperPage>
  );
};

export default React.forwardRef(SiteLayout);
